import { Modal } from "antd";
import i18nModule from "../../i18";

/**
 * Confirmation dialog for destructive / dangerous actions.
 * High zIndex so it also shows above the full-screen POS overlay.
 */
export function confirmDanger({
  title,
  content,
  okText,
  cancelText,
  onOk,
  zIndex = 4000,
}) {
  const tr = (key, defaultValue) => i18nModule.t(key, { defaultValue });
  Modal.confirm({
    title: title ?? tr("confirm.dangerTitle", "Are you sure?"),
    content: content ?? tr("confirm.dangerContent", "This action cannot be undone."),
    okText: okText ?? tr("common.delete", "Delete"),
    okType: "danger",
    cancelText: cancelText ?? tr("common.cancel", "Cancel"),
    centered: true,
    zIndex,
    onOk,
  });
}
